import axios from 'CanExConfig/axios'

export const fetchInterviewRequests = async (id, queryString) => {
  const response = await axios(`/api/candidate/profiles/${id}/interview_requests?${queryString}`, {
    method: 'get',
  })

  return response.data
}

export const fetchInterviewRequestDetail = async id => {
  const response = await axios(`/api/candidate/interview_requests/${id}`, {
    method: 'get',
  })

  return response.data
}

export const fetchInterviewRequestCounts = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/request_counts`, {
    method: 'get',
  })

  return response.data
}

export const setInterviewRequestStatus = async (id, data) => {
  const response = await axios(`/api/candidate/interview_requests/${id}/status`, {
    method: 'put',
    data,
  })

  return response.data
}

export const setInterviewRequestCandidateStatus = async (id, data) => {
  const response = await axios(`/api/candidate/interview_requests/${id}/candidate_status`, {
    method: 'put',
    data,
  })

  return response.data
}

export const setInterviewRequestDeclineReason = async (id, data) => {
  const response = await axios(`/api/candidate/interview_requests/${id}/decline_reason`, {
    method: 'put',
    data,
  })

  return response.data
}
